export const AppRouteURL = {  
  // LATEST_HOME: "/latesthome",
    HOME:'/home',
    PREMIUM:'/',
    SEARCH: '/search',
    LOGIN: "auth/login",
    LOGOUT: "auth/logout",
    PROFILE_INFORMATION: "/user/profile",
    PROFILE_MANAGE_ORDERS: "/user/order",
    PROFILE_VIRTUAL_LIBRARY: "/user/library",
    PROFILE_WISHLIST: "/user/wishlist",
    PROFILE_WALLET: "/user/wallet",
    PROFILE_LINKED_DEVICE:'/user/linked-devices', 
    PROFILE_MANAGE_SUBSCRIPTIONS: "/user/subscription", 
    SETTINGS: '/setting',
    MANAGE_NEWSLETTER:'/user/my-newsletter',
    REFER_AND_EARN: "/user/refer-and-earn",
    MANAGE_ADDRESS: "/user/address",
    GSTIN_DETAILS: "/user/gstin",
    CHANGE_PASSWORD: "/user/change-password",
    MANAGE_INTEREST: "/user/interests",
    PRICING_PAGE:"/pricing"
     
  };
